import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

const dsn = import.meta.env.VITE_SENTRY_DSN
const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1')
const devEnabled = import.meta.env.VITE_SENTRY_ENABLE_DEV === 'true'

if (dsn) {
  Sentry.init({
    dsn,
    enabled: !import.meta.env.DEV || devEnabled,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    tracesSampleRate,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  })
}

export { Sentry }
